import React from 'react';
import { H1, BodyLarge } from '../type';
import DividerHeader from '../divider-header';
import Container from '../container';
import SectionHeader from '../section-header';
import StrikeThrough from '../strike-through';
import styled from 'styled-components';
import * as vars from '../../styles/vars';

const About = () => {
  return (
    <>
      <Container id="about">
        <DividerHeader title="About" data-anim-in />
      </Container>
      <SectionHeader slim lessTopPadding zeroBottomPadding>
        <div data-anim-in>
          <H1 as="h3">Location</H1>
          <p>
            I&apos;m based in <StrikeThrough>sunny,</StrikeThrough>{' '}
            <StrikeThrough>rainy,</StrikeThrough>{' '}
            <StrikeThrough>hot,</StrikeThrough>{' '}
            <StrikeThrough>cold,</StrikeThrough>{' '}
            <StrikeThrough>misty,</StrikeThrough>{' '}
            <StrikeThrough>windy,</StrikeThrough>
            <br /> spider filled &ndash; Melbourne, Australia
          </p>
        </div>
      </SectionHeader>
      <SectionHeader slim lessTopPadding>
        <ProseWithInlineLinks data-anim-in>
          <H1 as="h3">Skills/experience</H1>
          <p>
            I&apos;ve been building and designing digital platforms &amp;
            products for a long time. I care about practical, maintainable
            front-end work: accessible interfaces, thoughtful UX, sensible
            architecture and the tiny details that make a product feel good to
            use.
          </p>
          <p>
            Coding agents let me move fast and cover more ground these days, but
            I review every line - nothing ships that I don&apos;t understand and
            own. Speed without the slop.
          </p>
        </ProseWithInlineLinks>
      </SectionHeader>

      <Container slim>
        <SubHeading data-anim-in>Stuff I'm really good at:</SubHeading>

        <BigList>
          <li data-anim-in>React</li>
          <li data-anim-in>JavaScript/TypeScript</li>
          <li data-anim-in>CSS/Tailwind CSS</li>
          <li data-anim-in>Next.js</li>
          <li data-anim-in>Front-end architecture</li>
          <li data-anim-in>AI/LLM integration</li>
          <li data-anim-in>Craft CMS</li>
          <li data-anim-in>Interaction design</li>
          <li data-anim-in>Accessibility</li>
          <li data-anim-in>UX principles</li>
          <li data-anim-in>Attention to detail</li>
        </BigList>

        <SubHeading data-anim-in>Soft skills:</SubHeading>

        <BigList>
          <li data-anim-in>Always learning</li>
          <li data-anim-in>Motivated</li>
          <li data-anim-in>Organised</li>
          <li data-anim-in>Jolly nice chap</li>
        </BigList>

        <BodyLarge data-anim-in>
          <p>
            And of course I'm used to using all the tools of any modern setup:
            Git, Linear, Figma etc, with plenty of experience in PR-based
            workflows, code review, CI/CD, Agile, Waterfall and whatever other
            shape the work needs to take.
          </p>
        </BodyLarge>
      </Container>

      <SectionHeader slim lessTopPadding zeroBottomPadding id="offcut">
        <div data-anim-in>
          <H1 as="h3">AI workflows and custom software</H1>
          <p>
            I also help businesses find the repetitive jobs that quietly eat
            hours, then build a practical way to take them off the team&rsquo;s
            plate.
          </p>
        </div>
      </SectionHeader>

      <Container slim>
        <BodyLarge>
          <ProseWithInlineLinks data-anim-in>
            <p>
              Sometimes that&rsquo;s a small workflow. Sometimes the job needs
              an agent or a piece of custom software.
            </p>
            <p>
              <a href="https://www.offcuthq.com/" data-hover>
                See how I do this at Offcut
              </a>
            </p>
          </ProseWithInlineLinks>
        </BodyLarge>
      </Container>
    </>
  );
};

const ProseWithInlineLinks = styled.div`
  p a {
    color: ${vars.colors.grey};
    text-decoration: underline;

    &:hover {
      color: ${vars.colors.black};
    }
  }
`;

const BigList = styled.ul`
  color: ${vars.colors.brand};
  font-family: ${vars.global.headingFontFamily};
  font-size: 42px;
  list-style: none;
  margin: 60px 0;

  ${vars.breakpoint.lg`
    margin: 60px 0 120px;
    font-size: 76px;
  `}

  li {
    line-height: 1;
    max-width: 900px;
    margin-bottom: 0.6em;
    padding-left: 0.45em;

    ${vars.breakpoint.lg`
      margin-bottom: 0.3em;
    `}

    &:before {
      content: '';
      display: inline-block;
      transform: translateY(calc(0.5em + 0.04em));
      position: absolute;
      opacity: 0.5;
      height: 0.08em;
      width: 0.8em;
      left: -0.7em;
      top: 0;
      background-color: ${vars.colors.brand};
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

// const MediumList = styled(BigList)`
//   ${vars.breakpoint.lg`
//     font-size: 60px;
//   `}

//   li {
//     ${vars.breakpoint.lg`
//       margin-bottom: 0.4em;
//     `}
//   }
// `;

const SubHeading = styled.h4`
  font-size: 30px;

  ${vars.breakpoint.lg`
    font-size: 40px;
  `}
`;

export default About;
